export default __webpack_public_path__ + "static/media/popup-desktop.d96a66d3.svg";